import { selectFilterHelper } from "@/helpers";
import { availableParentType } from "@/propTypes";
import { useGetAdminFlatFormsQuery, useGetFormPropertyQuery } from "@/services";
import { Form, Input, Select, Switch } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { FormFieldContainer } from "./styled";

export const DateRangeFormField = ({ availableParent }) => {
  const intl = useIntl();
  const [includeTime, setIncludeTime] = useState(false);
  const [parentId, setParentId] = useState();
  const [dependentValues, setDependentValues] = useState([]);

  const { data: formProperty } = useGetFormPropertyQuery();
  const { data: { flatForms } = {} } = useGetAdminFlatFormsQuery();

  useEffect(() => {
    if (!flatForms || !parentId) {
      setDependentValues([]);
      return;
    }

    const index = flatForms.findIndex(
      ({ property: { id } }) => id === parentId
    );

    if (!index < 0) return;

    const formValues = flatForms[index].values;

    if (!formValues) return;

    const values = formValues.map(({ id, label }) => ({
      value: id,
      text: intl.formatMessage({
        id: label.id,
        defaultMessage: label.fallback,
      }),
    }));

    setDependentValues(values);
  }, [parentId, flatForms, intl]);

  useEffect(() => {
    if (!formProperty?.property) return;

    setIncludeTime(formProperty.property.includeTime);
    setParentId(formProperty.property.timeParentField);
  }, [formProperty]);

  return (
    <FormFieldContainer>
      <Form.Item
        name={["property", "label", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={["property", "placeholder", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={["property", "requiredValidationText", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={["property", "includeTime"]}
        label={intl.formatMessage({
          id: "newFormField.includeTime",
        })}
        valuePropName="checked"
      >
        <Switch
          data-test-id="date-range-form-field-set-include-time"
          onChange={(toggled) => {
            setIncludeTime(toggled);
          }}
        />
      </Form.Item>
      {includeTime && (
        <>
          <Form.Item
            name={["property", "timeParentField"]}
            label={intl.formatMessage({
              id: "newFormField.timeParentField",
            })}
          >
            <Select
              data-test-id="date-range-form-field-set-parent-id"
              style={{ maxWidth: 500 }}
              allowClear
              onChange={(val) => {
                setParentId(val);
              }}
            >
              {availableParent.key && availableParent.items.length && (
                <Select.OptGroup
                  label={availableParent.key}
                  key={availableParent.key}
                >
                  {availableParent.items.map(({ value, text }) => (
                    <Select.Option key={value} value={value}>
                      {text}
                    </Select.Option>
                  ))}
                </Select.OptGroup>
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name={["property", "timeDependentValues"]}
            label={intl.formatMessage({
              id: "newFormField.timeDependentValues",
            })}
          >
            <Select
              mode="multiple"
              style={{ maxWidth: 500 }}
              disabled={!parentId}
              allowClear
              placeholder={intl.formatMessage({
                id: "newFormField.dependentValuesPlaceholder",
              })}
              filterOption={selectFilterHelper}
            >
              {dependentValues.map(({ value, text }) => (
                <Select.Option value={value} key={value}>
                  {text}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </>
      )}
    </FormFieldContainer>
  );
};

DateRangeFormField.propTypes = {
  availableParent: availableParentType,
};
